import { graphql } from "react-relay";

export const query = graphql`
  query SuggestedTimesQuery($orgRelayId: ID!, $query: SchedulingQueryInput!) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        schedulingResponseErrorable(query: $query) {
          ...EventSchedulerTimeInput_schedulingResponseErrorable @relay(mask: false)
        }
      }
    }
  }
`;

export const suggestedTimesRendererQuery = graphql`
  query SuggestedTimesQueryRendererQuery($calendarIds: [String]!, $orgRelayId: ID!) {
    node(id: $orgRelayId) {
      id
      ... on Org {
        personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
          __typename
          ... on PersonList {
            list {
              id
              emails
              primaryEmail
              profile {
                givenName
                familyName
                externalImageUrl
              }
              isYou
              isOutsideOrg
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        workingGroups(first: 1000000) {
          edges {
            node {
              id
              rooms {
                roomId
                name
                orgId
                estimatedCapacity
                reportedCapacity
                locationId
              }
            }
          }
        }
      }
    }
  }
`;
